import { render, staticRenderFns } from "./DetailCardContainer.vue?vue&type=template&id=0e62050c&scoped=true"
var script = {}
import style0 from "./DetailCardContainer.vue?vue&type=style&index=0&id=0e62050c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e62050c",
  null
  
)

export default component.exports